import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

const spin = keyframes`
  to { transform: rotate(360deg); }
`

export const Container = styled.div`
  max-width: 500px;
  margin: 3rem auto;
  padding: 2rem;
  text-align: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
`

export const IconWrapper = styled.div<{ $tone: 'success' | 'pending' }>`
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.$tone === 'success' ? '#4caf50' : '#9e9e9e')};
  border-radius: 50%;
  color: white;

  svg {
    width: 48px;
    height: 48px;
  }
`

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`

export const Title = styled.h2`
  font-size: 1.8rem;
  color: #2e7d32;
  margin-bottom: 1rem;
  font-weight: 600;
`

export const Message = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin: 0 auto 1rem;
  max-width: 80%;
`

export const Meta = styled.p`
  font-size: 0.85rem;
  color: #999;
  word-break: break-all;
`
